import api from "./baseApi";
import endpoints from "./endpoints";

/**
 * Get reports (unchanged - still GET)
 */
export const getReports = async (params = {}) => {
  try {
    const res = await api.get(endpoints.report.base, {
      params: {
        page: params.page || 1,
        perPage: params.perPage || 10,
        ...(params.filters || {}),
      },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch reports";
    throw new Error(message);
  }
};

// ================= REPORT GENERATION (NOW POST BODY) =================

export const generateRosterReport = async (params = {}) => {
  try {
    const res = await api.post(endpoints.report.roster, {
      date: params.date,
      venues: params.venues,
      type: params.type || "pdf",
      fileName: params.fileName,
    });

    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message || "failed to generate roster report"
    );
  }
};

export const generateReservationsReport = async (params = {}) => {
  try {
    const res = await api.post(endpoints.report.reservations, {
      startDate: params.startDate,
      endDate: params.endDate,
      venue: params.venue,
      status: params.status,
      type: params.type || "pdf",
      fileName: params.fileName,
    });

    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message || "failed to generate reservations report"
    );
  }
};

export const generateSlipsReport = async (params = {}) => {
  try {
    const res = await api.post(endpoints.report.slips, {
      startDate: params.startDate,
      endDate: params.endDate,
      venue: params.venue,
      status: params.status,
      type: params.type || "zip",
      fileName: params.fileName,
    });

    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message || "failed to generate slips report"
    );
  }
};

export const generateTransactionsReport = async (params = {}) => {
  try {
    const res = await api.post(endpoints.report.transactions, {
      startDate: params.startDate,
      endDate: params.endDate,
      channel: params.channel,
      status: params.status,
      type: params.type || "pdf",
      fileName: params.fileName,
    });

    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message || "failed to generate transactions report"
    );
  }
};

export const generateReceiptsReport = async (params = {}) => {
  try {
    const res = await api.post(endpoints.report.receipts, {
      startDate: params.startDate,
      endDate: params.endDate,
      venue: params.venue,
      receiptFrom: params.receiptFrom,
      receiptTo: params.receiptTo,
      type: params.type || "pdf",
      fileName: params.fileName,
    });

    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message || "failed to generate receipts report"
    );
  }
};

// ================= BATCH =================

export const generateReceiptsBatchReport = async (params = {}) => {
  try {
    const res = await api.post(endpoints.report.receiptsBatch, {
      startDate: params.startDate,
      endDate: params.endDate,
      venue: params.venue,
      receiptFrom: params.receiptFrom,
      receiptTo: params.receiptTo,
      type: "zip",
      fileName: params.fileName,
    });

    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message || "failed to generate receipts batch"
    );
  }
};

// ================= DELETE (UNCHANGED) =================
export const deleteReport = async (id) => {
  try {
    const res = await api.delete(endpoints.report.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to delete report";
    throw new Error(message);
  }
};